import * as ActionTypes from '../ActionTypes';


export const GetEACUserAction = (params) => {
    return {
        type: ActionTypes.GET_EAC_USER_REQUEST,
        params,
    };
};

export const AddEACUserAction = (params, callback) => {
    return {
        type: ActionTypes.ADD_EAC_USER_REQUEST,
        params,
        callback
    };
};

export const UpdateEACUserAction = (params, callback) => {
    return {
        type: ActionTypes.UPDATE_EAC_USER_REQUEST,
        params,
        callback
    };
};

